// Small shared helpers for the ME journey.

const SUBS = "₀₁₂₃₄₅₆₇₈₉";

export function meLabel(n) {
  return "ME" + String(n).split("").map((d) => SUBS[Number(d)]).join("");
}

export function greeting() {
  const h = new Date().getHours();
  if (h < 12) return "Good morning";
  if (h < 18) return "Good afternoon";
  return "Good evening";
}

export function formatDateGB(iso) {
  const d = iso ? new Date(iso) : new Date();
  return d.toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" });
}

export function daysSince(iso) {
  if (!iso) return null;
  const then = new Date(iso).getTime();
  return Math.floor((Date.now() - then) / (1000 * 60 * 60 * 24));
}

export const totalPrompts = (state) =>
  state.sections.reduce((a, s) => a + s.prompts.length, 0);

export const answeredCount = (answers, state) =>
  state.sections.reduce(
    (a, s) => a + s.prompts.filter((p) => (answers?.[p.id] || "").trim()).length,
    0
  );

export const stateLabel = (state) =>
  state.id === 0 ? "Baseline" : `Month ${state.id} of 11`;
